import React, { Component } from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";

class FirstSaturdayPage extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container position-relative p-0">
          <MenuBar />
        </div>
        <div >
          {/* Title Section with Overlay */}
          <div className="container-fluid p-0">
            <div
              className="banner-image "
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/First-Saturday-Bible-Convention-Banner.jpg)`,
              }}
            >
              <div className="banner-heading text-center">
              <h1 className="text-white">First Saturday Convention</h1>
              </div>
            </div>
          </div>

          <div className="container mt-4 mb-5">
            {/* Alternating Image and Text Sections */}
            <div className="row mb-5">
              {/* First Row: Image on the Left, Text on the Right */}
              <div className="col-md-6">
                <img
                  className="img-fluid"
                  src={`${process.env.PUBLIC_URL}/images/First-Saturday-Conventions.jpg`}
                  alt="Bishops"
                />
              </div>
              <div className="col-md-6 d-flex align-items-center">
                <p>
                  For the past 15 years First Saturdays are special days for
                  thousands of faithful who converge at Marian to attend the
                  First Saturday Convention led by Rev. Fr. Dominic. They come
                  from far and near, cutting across language, nationality, and
                  religion. The convention has the crucified Jesus at its centre
                  and it starts at 9.00 am and goes up to 3.00 pm corresponding
                  to the time our Lord was suffering on the cross. The
                  convention has powerful sessions of praise and worship,
                  preaching the Word of God, Holy Mass, Eucharistic Adoration
                  and Eucharistic Procession. After the Holy Mass, Rev. Fr.
                  Dominic lays his hands on each and every participant, and
                  gives them the blessing of deliverance and healing. Thousands
                  of miracles happen every First Saturday at Marian Retreat
                  Centre. Evil spirits flee from persons who were held captive
                  by them for long years. Many have made it a practice to attend
                  the convention for nine consecutive months. Prior registration
                  is not required, nor is it possible due to the large number of
                  attendees.
                </p>
              </div>
            </div>

            <div className="row mb-5">
              {/* Second Row: Text on the Left, Image on the Right */}
              <div className="col-md-6 d-flex align-items-center">
                <h4><u>Timings</u></h4>
                <p>Saturday 4:00 AM to 11:00 AM GMT</p>
                <p>Saturday 9:00 AM to 3:00 PM IST</p>
                <p>Friday 7:30 PM to 1:30 AM PST</p>
                <p>Friday 8:30 PM to 2:30 AM MST</p>
                <p>Friday 9:30 PM to 3:30 AM CST</p>
                <p>Friday 10:30 PM to 4:30 AM EST</p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 d-flex align-items-center">
                {/* Link Section */}
                <div className="text-end mt-4">
                  <a
                    href="https://marianretreatcentre.org/first-saturday-conventions/"
                    className="btn btn-outline-primary"
                  >
                    View Videos <i className="bi bi-arrow-right-circle"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterPanel />
      </React.Fragment>
    );
  }
}

export default FirstSaturdayPage;
